import { useColorMode } from "@/context/ColorModeContext";

export function GenisLogo({ size = "md", forceLight = false }) {
  const { mode } = useColorMode();
  const h = size === "sm" ? "h-8" : size === "lg" ? "h-16" : "h-11";
  const src = forceLight || mode === "dark" ? "/genis-logo-light.png" : "/genis-logo.png";
  return <img src={src} alt="Genis Energie" className={`${h} w-auto object-contain`} data-testid="genis-logo" />;
}
